var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty w-full h-full flex justify-center items-center"},[_c('div',{staticClass:"text-center"},[_c('i',{staticClass:"icon-EmptyBox"}),_c('div',{staticClass:"text-f-black-50 mt-lg"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }